export default store => store.editData;
